import React, { useState } from 'react';
import {
	FooterWrapper,
	FooterContainer,
	FooterMenu,
	NetworkSite,
	Copyright,
} from './styled';

const Footer = () => {
	const [family_toggle, set_family_toggle] = useState(0);

	const Toggle_family = () => {
		if (family_toggle) {
			set_family_toggle(0);
		} else {
			set_family_toggle(1);
		}
	};
	return (
		<FooterWrapper>
			<FooterContainer>
				<FooterMenu>
					<NetworkSite
						type="kbds"
						size="small"
						color="#666"
						background="#ffbc00"
						onClick={Toggle_family}
						on={family_toggle}
					>
						KB금융그룹 네트워크
						<img src={process.env.PUBLIC_URL + '/Vector.svg'} alt="" />
						<ul>
							<li>
								<a
									href="http://www.kbstar.com/"
									target="_blank"
									rel="noreferrer"
								>
									KB국민은행
								</a>
							</li>
							<li>
								<a
									href="http://www.kbsec.com/"
									target="_blank"
									rel="noreferrer"
								>
									KB증권
								</a>
							</li>
							<li>
								<a
									href="http://www.kbinsure.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB손해보험
								</a>
							</li>
							<li>
								<a
									href="https://card.kbcard.com/"
									target="_blank"
									rel="noreferrer"
								>
									KB국민카드
								</a>
							</li>
							<li>
								<a
									href="https://www.kblife.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB라이프생명
								</a>
							</li>
							<li>
								<a
									href="http://www.kbam.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB자산운용
								</a>
							</li>
							<li>
								<a
									href="http://www.kbcapital.co.kr"
									target="_blank"
									rel="noreferrer"
								>
									KB캐피탈
								</a>
							</li>
							<li>
								<a
									href="http://www.kbret.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB부동산신탁
								</a>
							</li>
							<li>
								<a
									href="http://www.kbsavings.com"
									target="_blank"
									rel="noreferrer"
								>
									KB저축은행
								</a>
							</li>
							<li>
								<a
									href="http://www.kbic.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB인베스트먼트
								</a>
							</li>
							<li>
								<a
									href="http://www.kds.co.kr/"
									target="_blank"
									rel="noreferrer"
								>
									KB데이타시스템
								</a>
							</li>
							<li>
								<a
									href="https://www.kbfg.com/kbresearch/index.do"
									target="_blank"
									rel="noreferrer"
								>
									KB경영연구소
								</a>
							</li>
						</ul>
					</NetworkSite>
				</FooterMenu>
				<Copyright>
					Copyright (c) 2020, KB Data Systems, All Rights Reserved.
				</Copyright>
			</FooterContainer>
		</FooterWrapper>
	);
};

export default Footer;
